import '../css/page.css';
import { TypeAnimation } from 'react-type-animation';
import { Container, Row } from 'react-bootstrap';

function Page3() {
  return (
    <div className='ContentWrapper' style={{ display: 'flex', height: window.innerWidth < 510 ? '40vh' : '20vh', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <Container>
        <div className='BlockWrapper' style={{ margin: '0 auto', width: '90%', height: 'auto' }}>
          <Container style={{ paddingTop: '0em', paddingBottom: '0em' }}>
            <Row>
              <h1 className='SubHeading'>Pathway AI</h1>
            </Row>
            <Row>
              <TypeAnimation
                sequence={[
                  'helps with your college applications', 
                  1000,
                  'helps with your scholarship search', 
                  1000,
                  'helps with your personal statement', 
                  1000,
                  'helps with your college search',
                  1000,
                  'helps with your college essays',
                  1000,
                  'helps with your college decisions',
                  1000,
                  'helps with your interview preparation', 
                  1000,
                  'helps with your resume', 
                  1000,
                  'helps with your internship search', 
                  1000,
                  'helps with your visa & study abroad process', 
                  1000,
                  'helps with your cost and tuition planning', 
                  1000,
                  'helps with your skill development', 
                  1000,
                  'helps with your common application', 
                  1000,
                  'helps with your essays', 
                  1000,
                  'helps with your future success', 
                  1000
                ]}
                wrapper="div"
                speed={50}
                style={{ fontSize: '2em', display: 'inline-block' }}
                repeat={Infinity}
              />
            </Row>
          </Container>
        </div>
      </Container>
    </div>
  );
}

export default Page3;

// TODO: A page specifically for more detailed features, the comparison feature
// take your next step with confidence